/*********************************************************************************************
* Initialize the sticky CTA behavior.
	* 
*/
function initializeStickyCTA() {
	const classicCTA = document.querySelector('[data-cta]');
	const stickyCTA = document.querySelector('[data-sticky-cta]');

	// Vérifie que les éléments existent
	if (!classicCTA || !stickyCTA) {
		console.error("Les éléments [data-cta] ou [data-sticky-cta] n'existent pas.");
		return;
	}

	// Crée un observateur pour surveiller la visibilité du CTA principal
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
				// Si le CTA principal n'est plus visible
				stickyCTA.classList.add('mm-sticky-cta-false');
			} else {
				// Si le CTA principal est visible
				stickyCTA.classList.remove('mm-sticky-cta-false');
			}
		});
	}, {
		root: null, // viewport par défaut
		threshold: 0 // détecter si n'importe quelle partie de l'élément est visible
	});

	// Lancer l'observation du CTA principal
	observer.observe(classicCTA);
}

/*********************************************************************************************
* Initialize the Splide carousel for the reassurance slider.
	* 
*/
function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector("#slider-reassurance");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
		});
		main.mount();
	}
}

/*********************************************************************************************
* Change the quantity value in the input field and update the related prices.
	*
	* @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
	* @param {string} inputId - The ID of the input field where the quantity is adjusted.
*/
function mmChangeQtty(delta, inputId) {
    let input = document.getElementById(inputId);
    const plusBtn = document.querySelector(`[data-qtty-plus="${inputId}"]`);

    if (delta === -1 && input.value === "1") {
        return;
    } else {
        var newValue = parseInt(input.value, 10) + parseInt(delta, 10);

        // Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
        if (input.max && newValue >= parseInt(input.max, 10)) {
            newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
            plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
        } else {
            plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
        }

        // Mise à jour de la valeur de l'input
        input.value = newValue;

        // Mise à jour des prix en fonction de la nouvelle quantité
        mmUpdatePrice(newValue);

        // Synchroniser le deuxième champ d'input (mobile) avec la première quantité
        const inputMobile = document.getElementById(inputId === 'quantity_section_id' ? 'quantity_section_id_mobile' : 'quantity_section_id');
        inputMobile.value = newValue;
    }
}


/*********************************************************************************************
* Update the displayed prices based on the new quantity.
	*
	* @param {number} qtty - The current product quantity used to calculate the prices.
*/
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price-ttc]"); 
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");
	var priceHtAll = document.querySelectorAll("[data-price-ht]"); // Ajout pour les prix HT

	// Fonction pour formater les prix
	function formatPrice(value) {
		var roundedValue = (value / 100).toFixed(2); // Convertit en euros avec 2 décimales
		var [integer, decimal] = roundedValue.split("."); // Sépare la partie entière et la partie décimale

		// Si la partie décimale est "00", ne pas l'afficher
		return decimal === "00" ? `${integer}€` : `${integer},${decimal}€`;
	}

	// Met à jour les prix TTC
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.priceTtc);
		if (!isNaN(priceValue)) {
			price.innerHTML = formatPrice(priceValue * qtty);
		} else {
			console.error("Valeur de prix non valide (TTC) : ", price.dataset.priceTtc);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			comparePrice.innerHTML = formatPrice(comparePriceValue * qtty);
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});

	// Met à jour les prix HT
	priceHtAll.forEach(function (priceHt) {
		var priceHtValue = parseFloat(priceHt.dataset.priceHt);
		if (!isNaN(priceHtValue)) {
			priceHt.innerHTML = formatPrice(priceHtValue * qtty);
		} else {
			console.error("Valeur de prix non valide (HT) : ", priceHt.dataset.priceHt);
		}
	});
}

/*********************************************************************************************
* Class for handling variant selection
	* 
*/
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	* Handle variant change event.
		* 
	*/
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
                this.updateImagesVariant();
            } else {
                // this.updateMedia();
            }
            this.variantFetch();
		}
	}

	/*********************************************************************************************
	* Get selected options from the variant checkboxes.
		*
	*/
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	* Get variant data from the embedded JSON.
		*
		* @returns {Object} - The variant data.
	*/
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	* Get the selected variant based on selected options.
		*
	*/
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	* Update the URL to include the selected variant ID.
		*
	*/
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	* Fetch variant data from the server and cache it.
		*
	*/
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	* Render variant information in the DOM.
		*
		* @param {Document} html - The HTML document containing the variant information.
	*/
	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateElementOuter(".mm-product-form-info-price", html);
		this.updateMultipleElement(".mm-product-form-variant-value", html);
		this.updateElementOuter(".mm-product-form-quantity", html);
		this.updateElementOuter(".mm-product-form-cta", html);
		this.updateElementOuter(".mm-product-form-price-ttc-mobile", html);
		// this.updateImagesVariant();
	}

	/*********************************************************************************************
	* Update the inner HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of multiple elements.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateMultipleElement(selector, html) {
        const destination = this.container.querySelectorAll(selector);
        const source = html.querySelectorAll(selector);

        if (source && destination) {
            for (let index = 0; index < source.length; index++) {
                destination[index].outerHTML = source[index].outerHTML;
            }
        }
    }

	/*********************************************************************************************
	* Update the media carousel to display the featured media of the current variant.
		*
	*/
	updateMedia() {
        if (this.currentVariant.featured_media != null) {
            var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");
            var variant_media_id = this.currentVariant.featured_media.id;
            allMainMedia.forEach((media) => {
                if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
                    var pagination = document.querySelectorAll(".mm-product-medias .splide__pagination li")[parseInt(media.dataset.index)];
                    pagination.querySelector("button").click();
                }
            });
        }
    }

	/*********************************************************************************************
	* Update the visibility of the media sliders for the current variant.
		*
	*/
	updateImagesVariant() {
        var allMainMedia = document.querySelectorAll(".mm-media-main-splide");
        allMainMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
        var allThumbnailMedia = document.querySelectorAll(".mm-media-thumbnail-splide");
        allThumbnailMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
    }
}

/*********************************************************************************************
* Define the custom element
	*
*/
customElements.define("variant-selector", VariantSelector);

/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	mmSlideProductReassurance();
	initializeStickyCTA();
});


/*********************************************************************************************
* Ymgometre
	*
*/
document.addEventListener('DOMContentLoaded', function () {
    // Sélectionner les éléments sur lesquels l'utilisateur peut cliquer
    const yumgometreEgg = document.querySelector('.mm-product-form-yumgometre-egg');
    const yumgometreGramme = document.querySelector('.mm-product-form-yumgometre-grams');
    const yumgometreSecondEgg = document.querySelector('.mm-product-form-yumgometre-second-egg');
    const yumgometreSecondGramme = document.querySelector('.mm-product-form-yumgometre-second-grams');

    // Définir "egg" comme actif par défaut
    yumgometreEgg.classList.add('active');
    yumgometreSecondEgg.classList.add('active');

    // Fonction pour activer/désactiver les classes
    function setActive(isEggActive) {
        if (isEggActive) {
            yumgometreEgg.classList.add('active');
            yumgometreSecondEgg.classList.add('active');
            yumgometreGramme.classList.remove('active');
            yumgometreSecondGramme.classList.remove('active');
        } else {
            yumgometreEgg.classList.remove('active');
            yumgometreSecondEgg.classList.remove('active');
            yumgometreGramme.classList.add('active');
            yumgometreSecondGramme.classList.add('active');
        }
    }

    // Ajouter les écouteurs d'événements de clic
    yumgometreEgg.addEventListener('click', function () {
        setActive(true);
    });

    yumgometreGramme.addEventListener('click', function () {
        setActive(false);
    });
});

// Récupération des éléments HTML
const qtyEggInput = document.getElementById('yumgometre_quantity_egg');
const qtyGramsInput = document.getElementById('yumgometre_quantity_grams');

// Récupération des données dynamiques
const { setEgg, setConversion, setProduit, setText2, setText3 } = document.querySelector('.mm-product-form-yumgometre').dataset;
const yumgometreEgg = parseFloat(setEgg);
const yumgometreConversion = parseFloat(setConversion);
const yumgometreProduit = parseFloat(setProduit);
const yumgometreQuantity2 = parseFloat(setText2);
const yumgometreQuantity3 = parseFloat(setText3);

// Fonction pour ajuster la quantité
function adjustQuantity(type, direction) {
    if (type === 'egg') {
        let qtyEggs = Math.max(1, parseInt(qtyEggInput.value) + (direction === 'increase' ? 1 : -1));
        qtyEggInput.value = qtyEggs;
        updateValues('egg');
    } else if (type === 'grams') {
        let qtyGrams = Math.max(yumgometreConversion, parseInt(qtyGramsInput.value) + (direction === 'increase' ? yumgometreConversion : -yumgometreConversion));
        qtyGramsInput.value = qtyGrams;
        updateValues('grams');
    }
}

// Fonction pour mettre à jour les valeurs
function updateValues(type) {
    if (type === 'egg') {
        updateGramsFromEggs();
    } else if (type === 'grams') {
        updateEggsFromGrams();
    }
    updateProductValues();
}

// Fonction pour mettre à jour les grammes à partir des œufs
function updateGramsFromEggs() {
    const qtyEggs = parseFloat(qtyEggInput.value);
    if (!isNaN(qtyEggs)) {
        qtyGramsInput.value = Math.round(qtyEggs * yumgometreConversion);
    }
}

// Fonction pour mettre à jour les œufs à partir des grammes
function updateEggsFromGrams() {
    const qtyGrams = parseFloat(qtyGramsInput.value);
    if (!isNaN(qtyGrams)) {
        qtyEggInput.value = Math.round(qtyGrams / yumgometreConversion);
    }
}

// Fonction pour mettre à jour toutes les valeurs du produit
function updateProductValues() {
    const qtyEggs = parseFloat(qtyEggInput.value);
    const productValues = {
        'mm-yumgometre-quantity-product-egg': qtyEggs * yumgometreProduit,
        'mm-yumgometre-quantity-product-grams': qtyEggs * yumgometreProduit,
        'mm-yumgometre-quantity-egg-2': qtyEggs * yumgometreQuantity2,
        'mm-yumgometre-quantity-grams-2': qtyEggs * yumgometreQuantity2,
        'mm-yumgometre-quantity-egg-3': qtyEggs * yumgometreQuantity3,
        'mm-yumgometre-quantity-grams-3': qtyEggs * yumgometreQuantity3
    };

    for (let id in productValues) {
        const element = document.getElementById(id);
        if (element) {
            element.textContent = Math.round(productValues[id]);
        }
    }
}

// Event listeners pour les boutons "+"
document.querySelector('[data-qtty-plus="yumgometre_quantity_egg"]').addEventListener('click', () => adjustQuantity('egg', 'increase'));
document.querySelector('[data-qtty-plus="yumgometre_quantity_grams"]').addEventListener('click', () => adjustQuantity('grams', 'increase'));

// Event listeners pour les boutons "-"
document.querySelector('[data-qtty-minus="yumgometre_quantity_egg"]').addEventListener('click', () => adjustQuantity('egg', 'decrease'));
document.querySelector('[data-qtty-minus="yumgometre_quantity_grams"]').addEventListener('click', () => adjustQuantity('grams', 'decrease'));


/*********************************************************************************************
 * Splide Media
 */
document.addEventListener('DOMContentLoaded', function() {
	var splideElemMain = document.querySelector('#main-slider');
	var splideElemThumbnails = document.querySelector('#thumbnail-slider');

	var main = new Splide(splideElemMain, {
		type			: 'slide',
		pagination		: false,
		arrows			: false,
		perMove     	: 1,
		gap				: '4px',
		focus			: 'center',
		breakpoints: {
			990: {
			}
		}
	});

	var thumbnails = new Splide(splideElemThumbnails, {
		type			: 'slide',
		pagination		: false,
		arrows			: false,
		isNavigation	: true,
		perMove     	: 1,
		fixHeight 		: '12%',
		height			: '100%',
		direction		: 'ttb',
		gap				: '16px',
		breakpoints: {
			990: {
				direction		: 'ltr',
				width			: '100%',
			}
		}
	});

	main.sync(thumbnails);
	main.mount();
	thumbnails.mount();

	// Ajout du compteur de défilement et d'une variable pour contrôler le délai
	let scrollCounter = 0;
	const isScrolling = false; // Empêche les multiples défilements rapides

	splideElemMain.addEventListener('wheel', function (e) {
		// Ne pas empêcher le comportement par défaut si le défilement est vertical
		if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
			return;
		}

		// Empêche le comportement par défaut pour le défilement horizontal
		e.preventDefault();

		// Si un défilement est déjà en cours, on ignore le nouvel événement
		if (isScrolling) {
			return;
		}

		// Incrémente le compteur de défilements
		scrollCounter++;

		// Vérifie si le compteur atteint le seuil pour un mouvement
		if (scrollCounter >= 12) { // Seuil ajustable
			// Réinitialise le compteur
			scrollCounter = 0;

			// Active le verrouillage temporaire pour éviter les défilements multiples
			isScrolling = true;

			// Déplace la diapositive selon la direction du défilement horizontal
			if (e.deltaX < 0) {
				main.go('<'); // Mouvement vers la gauche
			} else if (e.deltaX > 0) {
				main.go('>'); // Mouvement vers la droite
			}

			// Désactive le verrouillage après un délai
			setTimeout(function () {
				isScrolling = false;
			}, 300); // Délai de 300ms (modifiable selon vos besoins)
		}
	});

});

let baseFormHeight = 0; // Variable pour stocker la hauteur initiale de mm-product-form

function adjustFormHeight() {
    // Sélection des éléments
    const eggElement = document.querySelector(".mm-product-form-yumgometre-second-egg");
    const gramsElement = document.querySelector(".mm-product-form-yumgometre-second-grams");
    const formElement = document.querySelector(".mm-product-form");

    if (eggElement && gramsElement && formElement) {
        // Récupérer les hauteurs des deux éléments
        const eggHeight = eggElement.offsetHeight;
        const gramsHeight = gramsElement.offsetHeight;

        // Trouver la hauteur maximale entre les deux
        const maxHeight = Math.max(eggHeight, gramsHeight);

        // Appliquer la nouvelle hauteur : base + maxHeight
        formElement.style.height = `${baseFormHeight + maxHeight}px`;
    } else {
        console.warn("Un ou plusieurs éléments nécessaires sont introuvables.");
    }
}

// Initialisation après chargement du DOM
document.addEventListener("DOMContentLoaded", function () {
    const formElement = document.querySelector(".mm-product-form");

    // Stocker la hauteur initiale de mm-product-form une seule fois
    if (formElement) {
        baseFormHeight = formElement.offsetHeight;
    }

    // Appliquer la hauteur initiale
    adjustFormHeight();

    // Ajouter un gestionnaire pour l'événement resize
    window.addEventListener("resize", adjustFormHeight);
});
